import { render, staticRenderFns } from "./imeiInfo.vue?vue&type=template&id=c131b824&scoped=true"
import script from "./imeiInfo.vue?vue&type=script&lang=js"
export * from "./imeiInfo.vue?vue&type=script&lang=js"
import style0 from "./imeiInfo.vue?vue&type=style&index=0&id=c131b824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c131b824",
  null
  
)

export default component.exports